import React from 'react';
import { I18nextProvider } from '@wix/wix-i18n-config';
import WelcomePageController from './WelcomePageController';

export function createWelcomePageApp(props) {
  const { i19n } = props;

  return (
    <I18nextProvider i18n={i19n}>
      <WelcomePageController {...props} />
    </I18nextProvider>
  );
}
